import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStudioDisplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconStudioDisplay"><Path d="M8.75 17.25H5.75C4.09315 17.25 2.75 15.9069 2.75 14.25V7.75C2.75 6.09315 4.09315 4.75 5.75 4.75H18.25C19.9069 4.75 21.25 6.09315 21.25 7.75V14.25C21.25 15.9069 19.9069 17.25 18.25 17.25H15.25M8.75 17.25V20.25H15.25V17.25M8.75 17.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconStudioDisplay;
